module.exports = __webpack_public_path__ + "img/3.ab7b1f40.jpg";